var _path, _g, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 19,
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.376.625c-.965 0-1.75.785-1.75 1.75s.785 1.75 1.75 1.75 1.75-.785 1.75-1.75-.786-1.75-1.75-1.75zm6 0c-.965 0-1.75.785-1.75 1.75s.785 1.75 1.75 1.75 1.75-.785 1.75-1.75-.786-1.75-1.75-1.75z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.75 12.854h2.372l.003-5.772c0-.246-.27-.457-.5-.457h-20.5c-.23 0-.5.2-.5.457v5.772H3m13.937-.5v5.855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10.354v7.23c0 .246.248.625.477.625H19.25c.23 0 .5-.38.5-.625v-7.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.375 12.354v5.855m2.75-7.855v7.855m-5.5-7.855v7.855"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.376.625c-.965 0-1.75.785-1.75 1.75s.785 1.75 1.75 1.75 1.75-.785 1.75-1.75S6.34.625 5.376.625z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.812 12.354v5.855"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTeam);
export default __webpack_public_path__ + "static/media/myTeam.eb6c760b484efada40d41684b02df70b.svg";
export { ForwardRef as ReactComponent };